import { RootState } from "../types";
import { LangCode } from "../../requests/localization/types";

export const getLocaleString = (state: RootState): LangCode =>
  state.localization.locale;
